import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-cream-100" data-id="element-92">
      <Header data-id="element-93" />
      <main className="flex-grow" data-id="element-94">{children}</main>
      <Footer data-id="element-95" />
    </div>;
}